import React from 'react'
import { Header, Text } from '@crossfit/ui'

function ErrorPage() {
  return (
    <>
      <Header size='large' as='h2' mb={[12, 6]}>
        Sorry!
      </Header>

      <Text mb={8}>
        We have experienced an error. Please try refreshing the page. Reach out
        to{' '}
        <a
          href='mailto:affiliatetools@crossfit.com'
          target='_blank'
          rel='noopener noreferrer'
        >
          affiliatetools@crossfit.com
        </a>{' '}
        if you continue to have an issue.
      </Text>
    </>
  )
}

export default ErrorPage
